// Englischer Katalog. Die Annotation `: Katalog` ist die zweite, gröbere
// Paritätsstufe: sie fängt einen ganzen Namespace ab, der hier fehlt oder zu
// viel ist. Die feine Prüfung Key-für-Key macht jede en-Namespace-Datei selbst.
import type { Katalog } from "../de";
import { blog } from "./blog";
import { calendar } from "./calendar";
import { common } from "./common";
import { datasets } from "./datasets";
import { documents } from "./documents";
import { labels } from "./labels";
import { mail } from "./mail";
import { nav } from "./nav";
import { notes } from "./notes";
import { overview } from "./overview";
import { projects } from "./projects";
import { questionnaires } from "./questionnaires";
import { settings } from "./settings";
import { shared } from "./shared";
import { tasks } from "./tasks";

export const en: Katalog = {
  common,
  nav,
  settings,
  shared,
  labels,
  mail,
  tasks,
  notes,
  documents,
  datasets,
  projects,
  overview,
  calendar,
  questionnaires,
  blog,
};
